import * as actions from 'actions/saalDataActions';
const defaultState = {
    listings: []
};
export default function saalListingsData(state = defaultState, action) {
    switch (action.type) {
        case actions.SET_SAAL_LISTINGS:
            const allIds = action.listings.map(listing => {
                return listing && listing.listingId;
            });
            return Object.assign({}, state, {
                listings: allIds
            });
        case actions.RESET_SAAL_LISTINGS:
            return defaultState;
        default:
            return state;
    }
}
